import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import useAttributionStore from '../attributionStore/useAttributionStore';
import useDashboardStore from '../dashboardStore/useDashboardStore';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import useMailCodeStore from '../mailCodeStore/useMailCodeStore';
import useParameterStore from '../parameterStore/useParameterStore';
import useWorkflowStore from '../workflowStore/useWorkflowStore';
import { applyStore, keysToPersist } from './applyStore';

const useApplyStore = createStore({
  creator: applyStore({
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
    useAttributionStore: lazyDependency(() => useAttributionStore),
    useDashboardStore: lazyDependency(() => useDashboardStore),
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
    useMailCodeStore: lazyDependency(() => useMailCodeStore),
    useParameterStore: lazyDependency(() => useParameterStore),
    useWorkflowStore: lazyDependency(() => useWorkflowStore),
  }),
  id: 'apply',
  middlewares: {
    devtools: true,
    persist: {
      partialize: (state) => pickState(state, keysToPersist),
    },
  },
});

export default useApplyStore;
